import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './fileTemplateForm';
import List from './fileTemplateList';

const settings = {
    pathRegister: paths.fileTemplateRegister,
    pathList: paths.fileTemplate,
    apiPath: 'file-templates',
    permissionAdmin: null,
    title: 'Template de arquivos',
    entity: 'fileTemplate',
};

const FileTemplate: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const FileTemplateList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { FileTemplate, FileTemplateList };
